import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
} from '@material-ui/core';
import clsx from 'clsx';


const useStyles = makeStyles(() => ({
  orderList: {
    lineHeight: 0.6
  },
}));

const OrderViewer = ({ data }) => {
  const classes = useStyles();
  const {
    increment_id,
    created_at,
    status,
    extension_attributes: {
      dermpro_fraud_score,
      shipping_assignments: shipping_details = [],
      mp_reward: {mp_reward_earn, mp_reward_discount}
    },
    billing_address: {
      firstname,
      lastname,
      city,
      email,
      region_code,
      postcode,
      street,
      telephone
    },
    items: orderItems = [],
    base_tax_amount,
    base_subtotal_invoiced,
    discount_amount,
    discount_description,
    base_grand_total,
    order_currency_code,
    shipping_description,
    shipping_amount,
    coupon_code,
    payment: { cc_type, cc_last4, method},
    remote_ip
  } = data;

  const address = shipping_details?.[0]?.shipping?.address;

  return (
    <div className="invoice-viewer">
      <div>
        <h4 className="ml-4 mb-6 text-48">Order Info</h4>
        <div className="viewer__order-info px-4 mb-4 flex justify-between items-center">
          <div>
            <h5 className="mb-4">Order Number <strong>#{increment_id}</strong></h5>
            <h5 className="mb-4">&nbsp;</h5>
            <h5 className="font-normal capitalize">
              <strong>Placed from IP: </strong> {remote_ip}
            </h5>
          </div>
          <div className="text-right">
            <h5 className="font-normal mb-4 capitalize">
              <strong>Order status:</strong> {status}
            </h5>
            <h5 className="font-normal mb-4 capitalize">
              <strong>Fraud Estimation:</strong> {dermpro_fraud_score}%
            </h5>
            <h5 className="font-normal capitalize">
              <strong>Order date: </strong> {created_at}
            </h5>
          </div>
        </div>

        <Divider />

        <div className={clsx('viewer__billing-info px-4 py-5 flex justify-between', classes.orderList)}>
          <div>
            <h5 className="mb-2">Billing Address:</h5>
            <p className="mb-4 capitalized dense">{firstname} {lastname}</p>
            <p className="mb-0 whitespace-pre-wrap ">{street}</p>
            <p className="mb-0 whitespace-pre-wrap">{city}, {region_code} {postcode}</p>
            <p className="mb-0 whitespace-pre-wrap">Phone: {telephone}</p>
            <p className="mb-0 whitespace-pre-wrap">Email: <a href={`mailto:${email}`}>{email}</a></p>
          </div>
          {address && (
            <div>
              <h5 className="mb-2">Shipping Address:</h5>
              <p className="mb-4 capitalized dense">{address.firstname} {address.lastname}</p>
              <p className="mb-0 whitespace-pre-wrap">{address.street}</p>
              <p className="mb-0 whitespace-pre-wrap">{address.city}, {address.region} {address.postcode}</p>
              <p className="mb-0 whitespace-pre-wrap">Phone: {address.telephone}</p>
              <p className="mb-0 whitespace-pre-wrap">Email: <a href={`mailto:${address.email}`}>{address.email}</a></p>
            </div>
          )}
          <div>
            <h5 className="mb-2">Payment Method:</h5>
            <p className="mb-0 whitespace-pre-wrap">Method: {method}</p>
            <p className="mb-0 whitespace-pre-wrap">CreditCard Type: {cc_type}</p>
            <p className="mb-0 whitespace-pre-wrap">Credit Card Number: xxxx-{cc_last4}</p>
            <p className="mb-0 whitespace-pre-wrap">The order was placed using: {order_currency_code}</p>
          </div>
          <div>
            <h5 className="mb-2">Shipping Method:</h5>
            <p className="mb-4 dense">{shipping_description}</p>
          </div>
        </div>

        <Card className="mb-4" elevation={0}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="pl-sm-24 w-100 font-bold">#</TableCell>
                <TableCell className="px-0 font-bold">Item Name</TableCell>
                <TableCell className="px-0 font-bold" align="center">Unit Price</TableCell>
                <TableCell className="px-0 font-bold" align="center">Qty</TableCell>
                <TableCell className="px-0 font-bold" align="center">Cost</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderItems.map((s, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell
                      className="pl-sm-24 capitalize"
                      align="left"
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="pl-0 capitalize"
                      align="left"
                    >
                      {s.name}
                    </TableCell>
                    <TableCell
                      className="pl-0 capitalize"
                      align="center"
                    >
                      ${s.price.toFixed(2)}
                    </TableCell>
                    <TableCell
                      className="pl-0 capitalize"
                      align="center"
                    >
                      {s.qty_ordered}
                    </TableCell>
                    <TableCell
                      className="pl-0"
                      align="center"
                    >
                      ${s.row_total.toFixed(2)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Card>

        <div className="px-4 flex justify-end">
          <div className="flex">
            <div className="pr-12">
              <p className="mb-4">Earned:</p>
              <p className="mb-4">Sub Total:</p>
              <p className="mb-4">Spend Points: </p>
              {/* TODO: Need to add data for commented fields into API */}
              {/* <p className="mb-4">Credit: </p> */}
              <p className="mb-4">Shipping &amp; Handling: </p>
              <p className="mb-4">Discount {discount_description ? `(${discount_description})` : null}:</p>
              <p className="mb-4">Tax:</p>
              {/* <p className="mb-4">Gift Cards:</p> */}
              <Divider />
              <p className="font-bold">Grand Total:</p>
              <Divider />
              <p className="font-bold">Coupon Applied:</p>
            </div>
            <div>
              <p className="mb-4">{mp_reward_earn ? mp_reward_earn : '0'} points</p>
              <p className="mb-4">${base_subtotal_invoiced.toFixed(2)}</p>
              <p className="mb-4">-${mp_reward_discount?.toFixed(2) || '0.00'}</p>
              {/* <p className="mb-4">credit</p> */}
              <p className="mb-4">${shipping_amount.toFixed(2)}</p>
              <p className="mb-4">-${(Math.abs(discount_amount).toFixed(2))}</p>
              <p className="mb-4">${base_tax_amount.toFixed(2)}</p>
              {/* <p className="mb-4">gift cards</p> */}
              <Divider />
              <p className="font-bold">${base_grand_total.toFixed(2)}</p>
              <Divider />
              <p className="font-bold">{coupon_code ? coupon_code : '-'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderViewer;
